import database from '../../model/firebase/firebase';

export const adminTypes = {
  FETCH_DATA: 'admin/GETTING_DATA',
  MANAGE_VACANCY: 'admin/MANAGEVACANCY',
  DELETE_VACANCY: 'admin/DELETE_VACANCY',
};

export const getVacancies = (vacancies) => ({
  type: adminTypes.FETCH_DATA,
  vacancies,
});

export const manageVacancy = (newValues) => ({
  type: adminTypes.MANAGE_VACANCY,
  newValues,
});

export const showVacanciesAdmin = () => async (dispatch, getState) => {
  const jobs = (
    await database.collection(`${getState().platform.platformName}/data/vacancies`).orderBy('createdAt', 'desc').get()
  ).docs.map((doc) => ({ ...doc.data() }));
  dispatch(getVacancies(jobs));
};
